import React, { FC, useState, useMemo } from "react";
// eslint-disable-next-line node/no-missing-import
import { useNavigate } from "react-router-dom";
// Components:
import AppIcons from "./AppIcons.tsx";
import DivE from "./DivE.tsx";
// Redux-hooks:
import { useAppSelector } from "../../libs/redux-hooks.ts";
// Reducers:
import { getLng, getShowDesktopIconsTitle } from "../../libs/reducer.ts";
// Types
import type {Tapp} from "../../types/uiapp.d.ts";

type componentProps = {
  app:Tapp, onAppClick?:(e:React.MouseEvent) => void
};

const OneSectionIcon:FC<componentProps> = (props) => {
  const navigate = useNavigate();
  const lng = useAppSelector(getLng);
  const showDesktopIconsTitle = useAppSelector(getShowDesktopIconsTitle);
  const rlng = (lng === "en" ? "ru" : "en");

  const [clicked, setClicked] = useState("");

  const icoTooltip = useMemo(() => (
    props.app["title_" + lng] || props.app["title_" + rlng] || props.app.title || ""
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ), [lng, props.app]);

  const icoTitle = useMemo(() => {
    const ttl = props.app["title_" + lng] || props.app["title_" + rlng] || props.app.title || "";
    return (ttl.length > 52 ? ttl.slice(0, 52) + "..." : ttl);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lng, props.app]);

  return (
    <DivE uk-tooltip={icoTooltip}
      onMouseDown={() => { setClicked("clicked") }} onMouseUp={() => { setClicked("") }}
      onTouchStart={() => { setClicked("clicked") }} onTouchEnd={() => { setClicked("") }}
      onMouseMove={() => { setClicked("") }} onTouchMove={() => { setClicked("") }}
      onClick={(e) => {
        if (props.onAppClick) {
          if (props.app.type === "link") { window.location.href = props.app.link || "/"; return }
          navigate(props.app.link || "/app"); // {state: {from: window.location.pathname}, replace: true}
          props.onAppClick(e)
        }
      }}
      className="rz-margin-left-right-5"
      style={showDesktopIconsTitle ? {cursor: "pointer", maxWidth: 128, minWidth: 82, width: (icoTitle.length > 11 ? "auto" : "")} : {cursor: "pointer"}}
    >
      <DivE className="uk-grid uk-child-width-1-1 uk-flex uk-flex-center">
        <DivE key={props.app.key + "-icon"} className="rz-width-1-1 uk-flex uk-flex-center">
          <AppIcons icopath={props.app.icon || "ai/AiFillCodeSandboxSquare"} attrs={{
            size: 60, color: props.app.iconColor, className: (props.app.iconClass || "") + " svg-shadow-hover " + clicked
          }} />
        </DivE>
        <DivE key={props.app.key + "-title"} className="rz-width-1-1 uk-text-center rz-txt-light" style={{fontSize: "0.9em"}}>
          {showDesktopIconsTitle ? icoTitle : undefined}
        </DivE>
      </DivE>
    </DivE>
  );
}

export default OneSectionIcon;
